export const countersRegex = /(((CN(TO|FR))|(PREC))[0-9])+/;
const numericalRegex = /^[0-9]*([,.][0-9]*)?$/;

export const modifyNullParams = (params: { [key: string]: string }) => {
  const countersKeys = Object.keys(params).filter((x) => countersRegex.test(x));
  const counters: Array<Record<string, string>> = [];
  const otherKeys = Object.keys(params).filter((x) => !countersRegex.test(x));
  const otherParams: Array<{ [index: string]: string }> = [];

  countersKeys.forEach((x) => {
    if (params[x] === "" || params[x] === null || !numericalRegex.test(params[x])) {
      counters.push({ [x]: "0" });
    } else {
      counters.push({ [x]: params[x] });
    }
  });
  otherKeys.forEach((x) => {
    if (params[x] === "" || params[x] === null) {
      otherParams.push({ [x]: "0" });
    } else {
      otherParams.push({ [x]: params[x] });
    }
  });
  return Object.assign({}, ...counters, ...otherParams);
};
